"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronDown } from "lucide-react";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { TransitionLink } from "@/components/transition-link";
import type { NavItem } from "@/layouts/nav-items";
import { cn } from "@/lib/utils";
interface MenuDropdownProps {
  item: NavItem;
  isActive?: boolean;
  openPopover: string | null;
  setOpenPopover: (label: string | null) => void;
  isFooter?: boolean;
  /** Header encolhido (h-17): o painel sobe junto para não descolar da navbar. */
  isCompact?: boolean;
  onPointerEnter?: () => void;
  onPointerLeave?: () => void;
}
export default function MenuDropdown(t0) {
  const $ = _c(43);
  const {
    item,
    isActive: t1,
    openPopover,
    setOpenPopover,
    isFooter: t2,
    isCompact: t3,
    onPointerEnter,
    onPointerLeave
  } = t0;
  const isActive = t1 === undefined ? false : t1;
  const isFooter = t2 === undefined ? false : t2;
  const isCompact = t3 === undefined ? false : t3;
  const pathname = usePathname();
  const [currentHash, setCurrentHash] = useState("");
  const [isMounted, setIsMounted] = useState(false);
  const triggerRef = useRef(null);
  const dropdownRef = useRef(null);
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsMounted(true);
      const updateHash = () => {
        setCurrentHash(window.location.hash);
      };
      updateHash();
      window.addEventListener("hashchange", updateHash);
      return () => {
        window.removeEventListener("hashchange", updateHash);
      };
    };
    t5 = [];
    $[0] = t4;
    $[1] = t5;
  } else {
    t4 = $[0];
    t5 = $[1];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[2] !== item.label || $[3] !== openPopover || $[4] !== setOpenPopover) {
    t6 = () => {
      if (openPopover !== item.label) {
        return;
      }
      const handlePointerDown = event => {
        const target = event.target;
        if (!(target instanceof Node) || triggerRef.current?.contains(target) || dropdownRef.current?.contains(target)) {
          return;
        }
        setOpenPopover(null);
      };
      document.addEventListener("pointerdown", handlePointerDown);
      return () => {
        document.removeEventListener("pointerdown", handlePointerDown);
      };
    };
    t7 = [item.label, openPopover, setOpenPopover];
    $[2] = item.label;
    $[3] = openPopover;
    $[4] = setOpenPopover;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  useEffect(t6, t7);
  let t8;
  if ($[7] !== currentHash || $[8] !== pathname) {
    t8 = href => {
      const [pathPart, hashPart] = href.split("#");
      const normalizedPath = pathPart || "/";
      if (hashPart) {
        return pathname === normalizedPath && currentHash === `#${hashPart}`;
      }
      return pathname === normalizedPath;
    };
    $[7] = currentHash;
    $[8] = pathname;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const isHrefActive = t8;
  let t9;
  if ($[10] !== pathname) {
    t9 = href_0 => href_0.startsWith("/#") && pathname === "/" ? href_0.replace("/", "") : href_0;
    $[10] = pathname;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const resolveHref = t9;
  const t10 = openPopover === item.label ? "bg-white/5 text-white" : isActive ? "bg-white/5 text-primary-300" : "text-white/80 hover:bg-white/5 hover:text-white";
  let t11;
  if ($[12] !== t10) {
    t11 = cn("flex h-auto w-full max-w-fit hover:cursor-pointer items-center rounded-2xl bg-transparent px-4 py-3 text-[15px] transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-300", t10);
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = openPopover === item.label;
  let t13;
  if ($[14] !== item.label || $[15] !== openPopover || $[16] !== setOpenPopover) {
    t13 = () => setOpenPopover(openPopover === item.label ? null : item.label);
    $[14] = item.label;
    $[15] = openPopover;
    $[16] = setOpenPopover;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = item.label;
  const t15 = openPopover === item.label && "rotate-180";
  let t16;
  if ($[18] !== t15) {
    t16 = cn("ml-2 h-4 w-4 transition-transform duration-200", t15);
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t16) {
    t17 = <ChevronDown className={t16} />;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== item.label || $[23] !== t11 || $[24] !== t12 || $[25] !== t13 || $[26] !== t17) {
    t18 = <button ref={triggerRef} className={t11} type="button" aria-expanded={t12} aria-haspopup="true" onClick={t13}>{t14}{t17}</button>;
    $[22] = item.label;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== isCompact || $[29] !== isFooter || $[30] !== isHrefActive || $[31] !== isMounted || $[32] !== item.groups || $[33] !== item.label || $[34] !== onPointerEnter || $[35] !== onPointerLeave || $[36] !== openPopover || $[37] !== resolveHref || $[38] !== setOpenPopover) {
    t19 = isMounted && createPortal(<div ref={dropdownRef} className={cn("menu-dropdown fixed left-1/2 z-9999 w-screen -translate-x-1/2", "transition-all duration-300 ease-in-out", isFooter ? "bottom-68" : isCompact ? "top-17" : "top-22.5", openPopover === item.label ? "pointer-events-auto translate-y-0 opacity-100" : "pointer-events-none translate-y-2 opacity-0")} onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave}><div className="border-b border-white/10 bg-[#1C1C1C] shadow-[0_24px_80px_rgba(0,0,0,0.38)]"><div className="mx-auto max-w-320 px-4 sm:px-6 lg:px-10 2xl:px-12 py-8 2xl:py-10"><div className="grid grid-cols-[1fr_1.35fr_1fr] gap-x-10 gap-y-8 2xl:gap-x-20">{item.groups?.map(group => <div key={group.label}><p className="tag mb-4">{group.label}</p><ul className="-ml-3 flex flex-col gap-3">{group.items.map(child => <li key={child.href}><TransitionLink href={resolveHref(child.href)} className={cn("group flex items-start gap-4 rounded-lg p-3 transition-colors duration-300 ease-in-out hover:bg-[#282828]", isHrefActive(child.href) && "bg-[#282828]")} onClick={() => setOpenPopover(null)}><span className="flex size-12 shrink-0 items-center justify-center rounded-lg bg-gray-1000"><Image src={child.icon} alt="" aria-hidden="true" className="size-9 object-contain" /></span><span className="flex flex-col gap-0.5"><span className={cn("block font-bricolage text-sm 2xl:text-base font-medium leading-[120%] tracking-[-1%] transition-colors", isHrefActive(child.href) ? "text-primary-300" : "text-white")}>{child.label}</span><span className="block text-xs leading-[160%] tracking-[1%] text-white/50 transition-colors group-hover:text-white/80">{child.description}</span></span></TransitionLink></li>)}</ul></div>)}</div></div></div></div>, document.body);
    $[28] = isCompact;
    $[29] = isFooter;
    $[30] = isHrefActive;
    $[31] = isMounted;
    $[32] = item.groups;
    $[33] = item.label;
    $[34] = onPointerEnter;
    $[35] = onPointerLeave;
    $[36] = openPopover;
    $[37] = resolveHref;
    $[38] = setOpenPopover;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t18 || $[41] !== t19) {
    t20 = <>{t18}{t19}</>;
    $[40] = t18;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
}